
import { defineComponent, PropType } from 'vue';
import { TFunction } from 'i18next';

export default defineComponent({
  name: 'EmhHideNotification',
  props: {
    t: {
      type: Function as PropType<TFunction>,
      required: true,
    },
  },
});
